<template>
  <div class="c-material-report">
    <DropFilter v-model="collapsible">
      <m-report-filter @on-change="filterData" />
    </DropFilter>

    <div class="c-m-table">
      <Tabs v-model="platform" class="c-table-list">
        <TabPane name="0" label="全部" class="c-pane"></TabPane>
        <TabPane name="1" label="Andriod" class="c-pane"></TabPane>
        <TabPane name="2" label="iOS" class="c-pane"></TabPane>
        <template slot="extra">
          <div class="extra-slot">
            <div class="c-show-switch">
              <span>仅显示有数据素材</span>
              <el-switch v-model="hasRecord" @change="onDataSwitchChange" :active-value="1" :inactive-value="0" />
            </div>
            <ElButton type="primary" @click="betch">批量素材对比</ElButton>
            <ElButton icon="md-download" @click="downData">数据导出</ElButton>
            <ElButton @click="modalColumn = true">自定义列</ElButton>
          </div>
        </template>
      </Tabs>
      <Viewport v-model="tableHeight" v-loading="loading">
        <ReportTable
          border
          stripe
          show-summary
          :data="tableList"
          :columns="tableCol"
          :summaries="summaries"
          :height="tableHeight"
          @selection-change="handleTableSelectChange"
          @sort-change="sortTable"
          @on-show="handleShow"
        >
          <template #control="{ scope }">
            <div>
              <p><el-button type="text" @click="handleDaily(scope.row.imageId)">分日数据曲线</el-button></p>
              <p><el-button type="text" @click="handleDetail(scope.row.imageId)">计划数据详情</el-button></p>
              <p><el-button type="text" @click="handleDrawer(scope.row)">素材播放曲线</el-button></p>
            </div>
          </template>
        </ReportTable>

        <el-pagination
          :total="total"
          :current-page.sync="pageIndex"
          :page-size="pageSize"
          :page-sizes="[10, 20, 30, 40, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="changePageIndex"
          @size-change="changePageSize"
          class="c-table-page pager"
          background
        />
      </Viewport>
    </div>

    <!-- 自定义列 -->
    <custom-column
      v-model="modalColumn"
      :data="columns"
      :sub-title="['基本数据', '报表数据', '创角LTV', '视频数据']"
      @on-select="selectColumn"
    />

    <!-- 播放曲线 -->
    <PlayChart
      v-model="playChartDrawer"
      :width="1320"
      :max="maxMaterIds"
      :mater-ids="materIds"
      :title="playTitle"
      :params="params"
      @on-select="materialSelectModal = true"
      @on-delete="handleDelMater"
      @on-reset="materIds = []"
    />

    <!-- 选择对比素材列表 -->
    <pick-material v-model="materialSelectModal" multiline @on-select="pickMaterialSelect" />
  </div>
</template>
<script>
import { HOST_API } from '@/api/config'
import { isArray } from '@/common/js/utils'
import mixinTable from './mixin_table'
import DropFilter from './components/drop-filter'
import CustomColumn from '@/components/converter/custom-column.vue'
import PickMaterial from '@/components/material/material.vue'
import columns from '../data/material_record_column.js'
import MReportFilter from './components/material-sum-filter.vue'
import ReportTable from './components/material-report-table.vue'
import PlayChart from './components/play-chart'

import { getMaterialRecordData } from '@/api/report.model'

export default {
  name: 'materialist',
  mixins: [mixinTable],
  components: { DropFilter, ReportTable, CustomColumn, MReportFilter, PlayChart, PickMaterial },
  computed: {
    tableCol() {
      return this.columns.filter((ret) => !ret.show)
    },
    playTitle() {
      if (this.materIds && this.materIds.length) return `素材名称：${this.materIds[0].imageName}`
      else return '素材名称：'
    }
  },
  methods: {
    getData(filter) {
      let params = {
        pageId: this.pageIndex,
        pageSize: this.pageSize,
        status: this.hasRecord,
        platform: parseInt(this.platform),
        sort: this.sort,
        order: this.order
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      getMaterialRecordData(params).then((data) => {
        this.loading = false
        if (!data) return
        const { list, page_info, sum_data } = data
        if (isArray(list) && page_info) {
          const { total_number } = page_info
          this.total = total_number || 0
          this.tableList = list.map((ret) => {
            if (ret.coverUrl && ret.coverUrl.indexOf(',') > -1) {
              const imgs = ret.coverUrl.split(',')
              ret.double = imgs.length === 2
              ret.multiple = imgs.length > 2
              ret.cover = imgs[0]
            } else ret.cover = ret.coverUrl
            ret.video = Boolean(ret.imgType === 2)
            return ret
          })
          this.summaries = sum_data || {}
        }
      })
    },
    handleTableSelectChange(val) {
      this.multipleSelection = val.slice(0, 6)
    },
    /**
     * @description: 批量素材对比
     */
    betch() {
      if (!this.multipleSelection || !this.multipleSelection.length) {
        this.$Message.warning('至少选择一个对比素材！')
        return false
      }
      const ids = this.multipleSelection.map((ret) => ret.imageId).join(',')
      const names = this.multipleSelection.map((ret) => ret.imageName).join(',')
      // 写入面包屑
      this.$store.commit('setIndexRoute', 'reportmedia') // 返回的路由名称
      this.$store.commit('setBreadcrumb', [
        {
          title: '素材统计列表',
          href: {
            to: 'reportmedia',
            query: {}
          }
        },
        {
          title: '素材数据对比'
        }
      ])
      this.$router.push({
        name: 'matercompare',
        query: {
          ids,
          names,
          beginTime: this.params.beginTime,
          endTime: this.params.endTime,
          platform: this.params.platform,
          mediaId: this.params.mediaId
        }
      })
    },
    handleShow(param) {
      const { src, video, row } = param
      const { videoUrl, coverUrl } = row
      const imgs = coverUrl.includes(',') ? coverUrl.split(',') : [coverUrl]
      this.$Gallery.open({ src, video, videoUrl, imgs })
    },
    /**
     * @description: 计划详情数据页面
     * @param {*} id
     */
    handleDetail(id) {
      const { beginTime, endTime, platform, mediaId, dataGameId, dataGroupId } = this.params

      this.$router.push({
        name: 'materialdetail',
        query: {
          id,
          beginTime,
          endTime,
          platform,
          mediaId,
          dataGameId,
          dataGroupId
        }
      })
    },
    /**
     * @description: 分日数据页面
     * @param {*} id
     */
    handleDaily(id) {
      const { beginTime, endTime, platform, mediaId } = this.params
      this.$router.push({
        name: 'materlifecycle',
        query: {
          id,
          beginTime,
          endTime,
          platform,
          mediaId
        }
      })
    },
    handleDrawer({ imageId, imageName }) {
      this.playChartDrawer = true
      this.materIds.push({ imageId, imageName })
    },
    pickMaterialSelect(items) {
      items = items.filter((ret) => !this.materIds.map((met) => met.imageId).includes(ret.imageId))
      const len = this.maxMaterIds - this.materIds.length
      const max = items.length - len
      if (max > 0) items.splice(len, max)
      this.materIds.push(...items)
    },
    handleDelMater(meta) {
      const index = this.materIds.findIndex((ret) => ret.imageId === meta)
      if (index > -1) this.materIds.splice(index, 1)
    },
    downData() {
      const path = '/api/ptom/media/downloadMaterialReport'
      const url = `${HOST_API}${path}?`
      const { pageId, pageSize, ...restSearchParams } = this.params

      const searchParams = {}
      for (const key in restSearchParams) {
        const value = restSearchParams[key]
        if (value && value !== -1) {
          searchParams[key] = value
        }
      }

      searchParams.sessionid = this.$store.state.token
      searchParams.status = this.hasRecord

      if (searchParams.planName) searchParams.planName = encodeURIComponent(searchParams.planName)
      if (searchParams.imageName) searchParams.imageName = encodeURIComponent(searchParams.imageName)

      const urlQueryString = new URLSearchParams(searchParams).toString()
      window.open(url.concat(urlQueryString))
    },
    onDataSwitchChange() {
      this.pageIndex = 1
      this.getData()
    }
  },
  watch: {
    columns: {
      handler(nVal) {
        const show = nVal.filter((ret) => !ret.show).map((met) => met.key)
        this.setCustomStorage('MaterCustomColumn', show)
      },
      deep: true
    },
    platform(nVal) {
      this.pageIndex = 1
      this.getData()
    }
  },
  data() {
    return {
      tableHeight: 330,
      collapsible: null, // 展开过滤器
      playChartDrawer: null, // 抽屉
      materialSelectModal: null,
      maxMaterIds: 16,
      platform: '0', // 默认全部平台
      hasRecord: 1, // 是否显示有数据素材
      columns: [], // 表格字段
      tableList: [], // 表格数据
      materIds: [], // 播放素材
      access: this.$store.state.accessAuth, // 权限编码
      summaries: {},
      params: {}
    }
  },
  created() {
    const shows = this.getCustomStorage('MaterCustomColumn')
    // 同步本地存储自定义列
    if (shows.length) {
      const local_shows = shows
        .filter((ret) => ret)
        .map((ret) => {
          const item = columns.filter((met) => met.key === ret).pop() || {}
          item.show = false
          return item
        })
      const extend_shows = columns
        .filter((ret) => !shows.includes(ret.key))
        .map((ret) => {
          ret.show = true
          return ret
        })
      this.columns = [...local_shows, ...extend_shows]
    } else {
      this.columns = [...columns]
    }
    // this.tableList.length && this.getData()
  }
}
</script>
<style lang="scss" scoped>
.c-material-report {
  .c-btn-group {
    line-height: 30px;
    height: 32px;
    border-radius: 3px;
    width: 100px;
    display: inline-block;
    vertical-align: middle;
  }

  .extra-slot {
    display: flex;
    align-items: center;
  }

  .c-show-switch {
    height: 24px;
    font-size: 14px;
    display: flex;
    align-items: center;
    padding: 0 10px 0 5px;

    span {
      padding: 0 8px;
    }
  }

  .c-table-list {
    height: 44px;

    .c-pane {
      height: 100%;
    }
  }

  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }
}
</style>
